"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignedDataConveyance = exports.SignedDataConveyanceType = void 0;
var SignedDataConveyanceType;
(function (SignedDataConveyanceType) {
    SignedDataConveyanceType["NONE"] = "NONE";
    SignedDataConveyanceType["INDIRECT"] = "INDIRECT";
    SignedDataConveyanceType["DIRECT"] = "DIRECT";
    SignedDataConveyanceType["ENTERPRISE"] = "ENTERPRISE";
})(SignedDataConveyanceType = exports.SignedDataConveyanceType || (exports.SignedDataConveyanceType = {}));
class SignedDataConveyance {
    static toLowerCaseEnum(param) {
        if (param === SignedDataConveyanceType.DIRECT) {
            return "direct";
        }
        else if (param === SignedDataConveyanceType.ENTERPRISE) {
            return "indirect";
        }
        else if (param === SignedDataConveyanceType.INDIRECT) {
            return "indirect";
        }
        else {
            return "none";
        }
    }
}
exports.SignedDataConveyance = SignedDataConveyance;
//# sourceMappingURL=SignedDataConveyance.js.map